import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import { STATUS_MAP } from '../../../../constants/statuses';

const StudentStatus = ({ value }) => {
    const { t } = useTranslation();

    const statusKey = STATUS_MAP[value];
    const translatedStatus = statusKey !== undefined ? t('users.' + statusKey) : '-';

    return <Typography variant="body1">{translatedStatus}</Typography>;
};

export default StudentStatus;
